import React from 'react';

const prepareAuthNotes = props => {
  const { errorPassword, errorPhone, message } = props;

  if (errorPassword || errorPhone) {
    return (
      <p className="login-form__note">
        <span className="error">{message}</span>
      </p>
    );
  }
  return null;
};

export default prepareAuthNotes;
